import * as React from 'react';
import AccessibilityOutlined from './accessibility-outlined';
import AccessibilityFilled from './accessibility-filled';
import type { IconCombinedProps } from './types';
const AccessibilityCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <AccessibilityFilled ref={ref} {...rest} />;
  }
  return <AccessibilityOutlined ref={ref} {...rest} />;
});
export default AccessibilityCombined;